<template>
    <transition name="fade">
        <div class="auth-modal">
            <div
                v-if="!showOneTimeContent"
                @click="closeByBackdrop"
                :style="[
                    isSponsor
                        ? { 'align-items': 'center', 'background-color': 'rgba(0, 0, 0, .5)', 'padding-top': '3%' }
                        : {}
                ]"
                class="modal-backdrop"
            >
                <div :style="[stage == 'loginOTP' ? { 'max-width': '500px' } : {}]" class="modal-box relative mx-auto">
                    <div v-if="isSponsor && headerSponsorImage" class="sponsor-logo">
                        <img :src="headerSponsorImage" alt="sponsor-logo" />
                    </div>
                    <div
                        :class="['modal-content relative', isSponsor ? 'mb-content sponsor-page' : '']"
                        :style="[
                            isSponsor ? { 'margin-top': '0' } : {},
                            stage == 'loginOTP' ? { 'min-width': 'unset' } : {}
                        ]"
                    >
                        <InnerLoader v-if="isLoading" />

                        <div class="modal-header">
                            <div class="text-right">
                                <i
                                    v-if="showCloseButton"
                                    @click="closeModal"
                                    class="fas text-grey fa-times text-xl shadow-text-none cursor-pointer"
                                ></i>
                            </div>
                        </div>

                        <div
                            :class="['modal-body', isSponsor ? 'sponsor-body' : '']"
                            :style="[
                                stage == 'loginOTP' ? { margin: 0, padding: 0 } : {},
                                sponsorPageAndNoMedia ? { 'row-gap': 0 } : {}
                            ]"
                        >
                            <div
                                :class="{
                                    'login-box': true,
                                    'sponsor-without-media': sponsorPageAndNoMedia
                                }"
                            >
                                <!-- loginPage -->
                                <template v-if="!isLoggedIn() && !sponsorPage">
                                    <div v-if="isSponsor" class="sponsor-box">
                                        <h1
                                            v-html="sponsorSetting.headline"
                                            class="sponsor-headline shadow-text-none text-center"
                                        ></h1>
                                        <p
                                            v-html="sponsorSetting.body"
                                            class="sponsor-body text-center shadow-text-none"
                                        ></p>
                                        <a
                                            v-html="sponsorSetting.button_message"
                                            @click.prevent="sponsorPage = true"
                                            class="sponsor-btn shadow-text-none cursor-pointer"
                                        ></a>
                                    </div>

                                    <div>
                                        <div v-if="stage == 'login'" class="login-form">
                                            <div class="text-center auth-popup-header">
                                                <h2
                                                    v-for="(line, index) in loginTitle"
                                                    :key="index"
                                                    class="text-xl md:text-2xl my-1 shadow-text-none"
                                                >
                                                    {{ isSponsor ? sponsorSetting.login_headline : line }}
                                                </h2>
                                                <span v-if="loginUnderline" class="font-size-16 shadow-text-none">
                                                    {{ loginUnderline }}
                                                </span>
                                            </div>

                                            <div :class="{ 'small-btn': smallLogo, 'max-w-xs mx-auto': true }">
                                                <GmailLoginButton
                                                    @try-login="isLoading = true"
                                                    @fail="isLoading = false"
                                                    @verified="verified"
                                                    :webview-redirect-to="webviewRedirectTo"
                                                    :disabled="show3rdPartyLogin === false"
                                                    :disabled-message="translate('auth_header_3rd_party_not_available')"
                                                    class="mb-2"
                                                />
                                                <VippsLoginButton
                                                    v-if="
                                                        geoLocation &&
                                                        (geoLocation.code === 'NO' || geoLocation.name === 'Norway')
                                                    "
                                                    @try-login="isLoading = true"
                                                    @fail="isLoading = false"
                                                    @verified="verified"
                                                    :webview-redirect-to="webviewRedirectTo"
                                                    :disabled="show3rdPartyLogin === false"
                                                    :disabled-message="translate('auth_header_3rd_party_not_available')"
                                                    class="mb-2"
                                                />
                                            </div>
                                            <div class="max-w-xs mx-auto my-4">
                                                <div class="separator">
                                                    {{ translate('auth_or') }}
                                                </div>
                                            </div>

                                            <div
                                                :class="`${isSchoolPage() ? 'max-w-school' : 'max-w-xs'} mx-auto my-4`"
                                            >
                                                <LoginForm
                                                    @try-login="isLoading = true"
                                                    @success="loginSuccess"
                                                    @fail="isLoading = false"
                                                    @toggle-register="toggleRegister"
                                                    @otp="openOneTimeLogin"
                                                    ref="submitLoginOtp"
                                                />
                                            </div>
                                            <div v-if="devMode" class="text-center">
                                                <a
                                                    @click.prevent="stage = 'forgot-password'"
                                                    class="text-sm no-underline text-black shadow-text-none"
                                                    href=""
                                                >
                                                    {{ translate('auth_button_forgot_password') }}
                                                </a>
                                            </div>
                                        </div>

                                        <div v-if="stage == 'add-email'" class="add-email-form">
                                            <div class="text-center" style="margin-bottom: 4rem">
                                                <h2 class="text-2xl my-1 shadow-text-none">
                                                    {{ translate('auth_add_email') }}
                                                </h2>
                                            </div>
                                            <AddEmailForm @add-email-success="addEmail" />
                                        </div>

                                        <div v-if="stage == 'register'" class="register-form">
                                            <div class="text-center" style="margin-bottom: 4rem">
                                                <h2 class="text-2xl my-1 shadow-text-none">
                                                    {{
                                                        isSchoolPage()
                                                            ? translate('auth_header_register_teacher')
                                                            : translate('auth_header_register')
                                                    }}
                                                </h2>
                                            </div>

                                            <RegisterForm
                                                @try-register="isLoading = true"
                                                @validate-fail="isLoading = false"
                                                @fail="isLoading = false"
                                                @registered="registerSuccess"
                                                @toggle-login="toggleLogin"
                                                @register-otp="onRegisterOtp"
                                                @open-confirm-to-teacher="openConfirmToTeacherModal($event)"
                                            />
                                        </div>

                                        <div v-if="stage == 'forgot-password'">
                                            <div class="text-center mb-4">
                                                <h2 class="text-2xl my-1 shadow-text-none">
                                                    {{ translate('auth_header_forgot_password') }}
                                                </h2>
                                            </div>
                                            <p class="text-center text-sm mb-4 shadow-text-none">
                                                {{ translate('auth_email_reset_password') }}
                                            </p>
                                            <ForgotPasswordForm
                                                @try-reset-password="isLoading = true"
                                                @sent-request="isLoading = false"
                                                @sent-request-fail="afterResetPassword()"
                                                @sent-request-success="afterResetPassword()"
                                                @toggle-login="toggleLogin"
                                            />
                                        </div>
                                    </div>
                                </template>
                                <!-- /loginPage -->

                                <!-- loggedPage -->
                                <template v-if="isSponsor && isLoggedIn() && !sponsorPage">
                                    <div class="sponsor-box">
                                        <h1
                                            v-html="sponsorSetting.headline_logged_in"
                                            class="sponsor-headline shadow-text-none text-center"
                                        ></h1>
                                        <p
                                            v-html="sponsorSetting.body_logged_in"
                                            class="sponsor-body text-center shadow-text-none"
                                        ></p>
                                    </div>
                                    <div class="flex flex-col">
                                        <a
                                            v-html="sponsorSetting.button_message_logged_in"
                                            @click.prevent="sponsorPage = true"
                                            class="sponsor-btn shadow-text-none cursor-pointer"
                                        ></a>

                                        <ShareSponsorQuizBox
                                            v-if="sponsorSetting.is_show_share_button"
                                            @click-title="isShareQuizModal = true"
                                            :title="sponsorSetting.sponsor_page_share_quiz_title"
                                            :message="sponsorSetting.sponsor_page_share_quiz_message"
                                            color="#dc3746"
                                            class="mt-4"
                                        />
                                    </div>
                                    <div class="max-w-xs contact-box w-full mx-auto text-left">
                                        <span class="contact-header shadow-text-none">
                                            {{ sponsorSetting.contact_headline }}
                                        </span>
                                        <div>
                                            <XCheckbox
                                                @input="changeContact(true)"
                                                :checked="contactSwitch"
                                                type="radio"
                                                name="contact"
                                                class="column-gap-16 contact-input-box"
                                                size="lg"
                                                theme="red"
                                            >
                                                <div>
                                                    <XInput
                                                        @change="
                                                            e => {
                                                                emailInput = e.target.value
                                                                onSubmitForm('contact', emailInput)
                                                            }
                                                        "
                                                        :class="{
                                                            'auth-input contact-input input-block input-text-alignment font-size-16 w-full': true,
                                                            'is-invalid': errors.has('email')
                                                        }"
                                                        :disabled="!contactSwitch"
                                                        :value="emailInput"
                                                        type="email"
                                                        placeholder="E-mail"
                                                        v-validate="'required|email'"
                                                        data-vv-validate-on="blur"
                                                        name="email"
                                                        id="email-input"
                                                    />
                                                    <div class="invalid-feedback">
                                                        <span
                                                            v-if="errors.has('email')"
                                                            class="has-error text-center shadow-text-none"
                                                        >
                                                            {{ errors.first('email') }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </XCheckbox>
                                        </div>
                                        <div>
                                            <XCheckbox
                                                @input="changeContact(false)"
                                                :checked="!contactSwitch"
                                                type="radio"
                                                name="contact"
                                                class="column-gap-16 contact-input-box"
                                                size="lg"
                                                theme="red"
                                            >
                                                <XInput
                                                    @change="
                                                        e => {
                                                            telInput = e.target.value
                                                            onSubmitForm('contact', telInput)
                                                        }
                                                    "
                                                    :class="{
                                                        'auth-input contact-input input input-block input-text-alignment font-size-16 w-full': true,
                                                        'is-invalid': errors.has('phone')
                                                    }"
                                                    :disabled="contactSwitch"
                                                    :value="telInput"
                                                    type="text"
                                                    placeholder="Phone number"
                                                    v-validate="'required|decimal|min:8|max:12'"
                                                    data-vv-validate-on="blur"
                                                    name="phone"
                                                    id="tel-input"
                                                />
                                                <div class="invalid-feedback">
                                                    <span
                                                        v-if="errors.has('phone')"
                                                        class="has-error text-center shadow-text-none"
                                                    >
                                                        {{ errors.first('phone') }}
                                                    </span>
                                                </div>
                                            </XCheckbox>
                                        </div>
                                        <div
                                            v-if="
                                                (contactSwitch && !errors.has('email')) ||
                                                (!contactSwitch && !errors.has('phone'))
                                            "
                                            class="my-4"
                                        >
                                            <div
                                                v-if="sponsorSetting.signup_maillist_message"
                                                class="flex items-center column-gap-16"
                                            >
                                                <XCheckbox
                                                    @input="
                                                        e => {
                                                            sponsorMaillist = e.target.checked
                                                            onSubmitForm('sponsor_maillist', sponsorMaillist)
                                                        }
                                                    "
                                                    :square="true"
                                                    :checked="sponsorMaillist"
                                                    type="checkbox"
                                                    name="receive"
                                                    class="column-gap-16"
                                                    size="lg"
                                                    theme="red"
                                                    id="receive-premiere-mail"
                                                >
                                                    <label
                                                        v-html="sponsorSetting.signup_maillist_message"
                                                        for="receive-premiere-mail"
                                                        class="receive-text shadow-text-none cursor-pointer"
                                                    ></label>
                                                </XCheckbox>
                                            </div>
                                            <div
                                                v-if="sponsorSetting.signup_news_message"
                                                class="flex items-center column-gap-16 mt-3"
                                            >
                                                <XCheckbox
                                                    @input="
                                                        e => {
                                                            tbqMaillist = e.target.checked
                                                            onSubmitForm('tbq_maillist', tbqMaillist)
                                                        }
                                                    "
                                                    :square="true"
                                                    :checked="tbqMaillist"
                                                    type="checkbox"
                                                    name="receive"
                                                    class="column-gap-16"
                                                    size="lg"
                                                    theme="red"
                                                    id="receive-weekly-quiz"
                                                >
                                                    <label
                                                        v-html="sponsorSetting.signup_news_message"
                                                        for="receive-weekly-quiz"
                                                        class="receive-text shadow-text-none cursor-pointer"
                                                    ></label>
                                                </XCheckbox>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <!-- /loggedPage -->

                                <!-- sponsorPage -->
                                <template v-if="isSponsor && sponsorPage">
                                    <div class="sponsor-box">
                                        <h1
                                            v-html="sponsorSetting.sponsor_page_headline"
                                            class="sponsor-headline shadow-text-none text-center"
                                        ></h1>
                                        <p
                                            v-html="sponsorSetting.sponsor_page_body"
                                            class="sponsor-body text-center shadow-text-none"
                                        ></p>
                                    </div>
                                    <div v-if="isSponsorVideo || sponsorImage" class="sponsor-video-box rounded">
                                        <VideoPlayer
                                            v-if="isSponsorVideo"
                                            @clickVideo="sponsorQuizTrack('video')"
                                            :video-meta="videoMeta"
                                            :video-path="videoMeta.video"
                                            :fullscreen="true"
                                            :sponsor="true"
                                            class="w-full h-full"
                                        />
                                        <img
                                            v-if="!isSponsorVideo && sponsorImage"
                                            :src="sponsorImage"
                                            class="object-cover w-full h-full"
                                            alt="sponsor-image"
                                        />
                                    </div>
                                    <div>
                                        <div>
                                            <a
                                                v-html="sponsorSetting.sponsor_page_button_message"
                                                @click="sponsorQuizTrack('button')"
                                                :href="sponsorSetting.sponsor_page_target_url"
                                                class="sponsor-btn shadow-text-none cursor-pointer"
                                                target="_blank"
                                            ></a>
                                        </div>
                                        <div class="my-4" v-if="!isLoggedIn()">
                                            <a
                                                v-html="sponsorSetting.sponsor_page_join_button_message"
                                                @click.prevent="sponsorPage = false"
                                                class="sponsor-btn shadow-text-none cursor-pointer"
                                                href=""
                                            ></a>
                                        </div>

                                        <ShareSponsorQuizBox
                                            v-if="sponsorSetting.is_show_share_button"
                                            @click-title="isShareQuizModal = true"
                                            :title="sponsorSetting.sponsor_page_share_quiz_title"
                                            :message="sponsorSetting.sponsor_page_share_quiz_message"
                                            color="#dc3746"
                                            class="mt-4"
                                        />
                                    </div>
                                    <div v-if="!isSponsorVideo && !sponsorImage" class="sponsor-box fake-box invisible">
                                        <h1
                                            v-html="sponsorSetting.sponsor_page_headline"
                                            class="sponsor-headline shadow-text-none text-center"
                                        ></h1>
                                        <p
                                            v-html="sponsorSetting.sponsor_page_body"
                                            class="sponsor-body text-center shadow-text-none"
                                        ></p>
                                    </div>
                                </template>
                                <!-- /sponsorPage -->
                            </div>
                            <XButton
                                v-if="isSponsor && isLoggedIn() && !sponsorPage"
                                @click.prevent="sponsorPage = true"
                                class="mx-auto ok-btn"
                            >
                                {{ $t('sponsor_button_ok') }}
                            </XButton>
                            <div v-if="sponsorPage" class="flex justify-center items-center compete-btn">
                                <a
                                    v-if="sponsorSetting.is_show_share_button"
                                    v-html="sponsorSetting.sponsor_page_competitions_page_button"
                                    @click.prevent="goToMyQuiz"
                                    class="shadow-text-none cursor-pointer underline font-size-16"
                                ></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <login-otp v-if="isLoginOtp" @close="isLoginOtp = false" @confirm-otp="onConfirmOtp"></login-otp>
             -->
            <OneTimeAuthModal
                v-if="showOneTimeModal"
                :is-one-time="isOneTime"
                @close="closeModal()"
                @fail="onFail"
                @confirm="handleInput"
                @on-otp-completed="
                    showOneTimeContent = true
                    showSetschoolModal = false
                "
                ref="oneTimeAuth"
            />
            <ShareQuizModal v-model="shareLinkUrl" v-if="isShareQuizModal" @close="isShareQuizModal = false" />

            <SetSchoolModal
                v-if="showSetschoolModal"
                @register-otp="onRegisterOtp"
                @close="showSetschoolModal = false"
                @register-success="loginSuccess"
                :form-set-school="cacheData"
                class="z-20"
            />
            <ConfirmToTeacher
                v-if="showConfirmToTeacherModal"
                @accept="openSetSchoolModal()"
                @reject="rejectCallback()"
            />
        </div>
    </transition>
</template>

<script>
import UserService from '@/lib/user.js'
import appConfig from '@/app.config.js'
import Request from '@/lib/request.js'
import { mapState } from 'vuex'
import GmailLoginButton from '@/components/GmailLoginButton'
import VippsLoginButton from '@/components/VippsLoginButton'
import RegisterForm from '@/components/RegisterForm'
import LoginForm from '@/components/LoginForm'
import ForgotPasswordForm from '@/components/ForgotPasswordForm'
import InnerLoader from '@/components/InnerLoader'
var CustomEvent = require('custom-event')
import helper from '@/lib/helper'
import AddEmailForm from '@/components/AddEmailForm'
import popup from '@/lib/popup.js'
import XCheckbox from '@/components/v2/XCheckbox.vue'
import XInput from '@/components/v2/XInput.vue'
import XButton from '@/components/v2/XButton.vue'
import VideoPlayer from '@/components/VideoPlayer.vue'
import helperMixins from '@/mixins/helper.js'
import ShareQuizModal from '@/components/ShareQuizModal'
import ShareSponsorQuizBox from '@/components/ShareSponsorQuizBox'
import OneTimeAuthModal from '@/components/OneTimeAuthModal'
import SetSchoolModal from '@/components/SetSchoolModal'
import ConfirmToTeacher from '@/components/ConfirmToTeacher'
import { load } from 'recaptcha-v3'

export default {
    name: 'AuthPopup',

    components: {
        RegisterForm,
        LoginForm,
        GmailLoginButton,
        ForgotPasswordForm,
        VippsLoginButton,
        InnerLoader,
        AddEmailForm,
        XCheckbox,
        XInput,
        VideoPlayer,
        XButton,
        ShareQuizModal,
        ShareSponsorQuizBox,
        OneTimeAuthModal,
        SetSchoolModal,
        ConfirmToTeacher
    },

    mixins: [helperMixins],

    props: {
        loginTitle: {
            type: Array,
            default() {
                return [this.$t('auth_header_login')]
            }
        },

        loginUnderline: {
            type: String,
            default: ''
        },

        showCloseButton: {
            type: Boolean,
            default: true
        },

        webviewRedirectTo: {
            type: String,
            default: '#'
        },

        showThirdPartyInWebview: {
            type: Boolean,
            default: true
        },

        sponsorQuiz: {
            type: Object
        },

        joinMenu: {
            type: Boolean
        },

        isMuted: {
            type: Boolean
        },

        isSeePosition: {
            type: Boolean,
            default: false
        },

        shareLinkUrl: {
            type: String
        },

        unsubscribe: {
            type: Boolean,
            default: false
        },
        preventNewsletterPopup: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            stage: 'login',
            isLoading: false,
            isEmailNull: false,
            user: null,
            sponsorPage: false,
            videoMeta: null,
            emailInput: '',
            telInput: '',
            sponsorMaillist: false,
            tbqMaillist: false,
            contactSwitch: true, //true = email, false = telephone
            tmpUserEmail: null,
            muted: false,
            smallLogo: true,
            isShareQuizModal: false,
            // isLoginOtp: false,
            fromLogIn: [],
            loginToken: null,
            otpNumber: null,
            enableResendOtp: false,
            resendCountdown: this.countdownOtp,
            loginOtpRef: null,
            isGoogle2fa: false,
            showOneTimeModal: false,
            showOneTimeContent: false,
            isOneTime: null,
            showSetschoolModal: false,
            showConfirmToTeacherModal: false,
            cacheData: null
        }
    },

    computed: {
        ...mapState({
            playMode: state => state.playMode,
            geoLocation: state => state.geoLocation
        }),

        show3rdPartyLogin() {
            if (!this.showThirdPartyInWebview && helper.webView()) {
                return false
            }

            return true
        },

        isSponsor() {
            if (typeof this.sponsorQuiz != 'undefined' && this.joinMenu) {
                return this.sponsorSetting ? true : false
            } else {
                return false
            }
        },

        sponsorSetting() {
            return this.sponsorQuiz.sponsor_setting
        },

        headerSponsorImage() {
            if (this.sponsorSetting.modal_image.length > 0) {
                return this.sponsorSetting.modal_image
            } else {
                return false
            }
        },

        sponsorImage() {
            if (this.sponsorSetting.sponsor_page_image.length > 0) {
                return this.sponsorSetting.sponsor_page_image
            }

            return false
        },

        isSponsorVideo() {
            if (
                typeof this.sponsorQuiz != 'undefined' &&
                typeof this.sponsorSetting != 'undefined' &&
                this.sponsorSetting.sponsor_page_youtube_id.length > 0
            ) {
                return this.sponsorSetting.sponsor_page_youtube_id ? true : false
            } else {
                return false
            }
        },

        userEmail() {
            const userService = new UserService()
            return this.tmpUserEmail || userService.getUser().email
        },

        sponsorPageAndNoMedia() {
            return this.sponsorPage && !this.isSponsorVideo && !this.sponsorImage
        }
    },

    mounted() {
        this.sponsorVideoMeta()
        if (this.isSeePosition) {
            this.loginTitle.splice(0, 1, this.$t('versus_login'))
        }

        if (this.unsubscribe) {
            this.openNewsletterModal()
        }
    },

    methods: {
        onFail() {
            this.showOneTimeModal = false
            this.showOneTimeContent = false
            this.isLoading = false
        },

        goToMyQuiz() {
            this.$router.replace({
                name: 'edit',
                params: {
                    id: this.sponsorQuiz._id.$oid,
                    slug: 'update'
                },
                query: {
                    type: 'competitions',
                    mode: this.playMode ? this.playMode : undefined
                }
            })
        },

        verified(user) {
            if (user.email == null) {
                this.user = user
                this.isLoading = false
                this.toggleAddEmail()
            } else {
                this.verifiedUser(user)
            }
        },

        authRequest() {
            const userService = new UserService()
            const token = userService.getToken()

            return {
                Authorization: `Bearer ${token}`
            }
        },

        addEmail(email) {
            const request = new Request()

            this.isLoading = true

            request
                .post(appConfig.api.checkEmail3rdParty, { email })
                .then(async () => {
                    this.user.email = email
                    await this.verifiedUser(this.user)
                })
                .catch(() => {
                    popup.alert(this.translate('auth_alert_already_email'))
                    this.isLoading = false
                })
        },

        verifiedUser(user) {
            let eventLabel = ''

            switch (user.provider) {
                case 'facebook':
                    eventLabel = 'Facebook_register'
                    break
                case 'gmail':
                    eventLabel = 'Gmail_register'
                    break
                case 'feide':
                    eventLabel = 'Feide_register'
                    break
                default:
                    eventLabel = 'Vipps_register'
            }

            user.eventLabel = eventLabel

            if (this.isSchoolPage() && user.is_created && !user.is_valid_invite_token) {
                user.thirdParty = true
                this.openConfirmToTeacherModal(user)
                return
            }

            this.login3rd(user)
        },

        async login3rd(user) {
            const request = new Request()

            return new Promise((resolve, reject) => {
                request
                    .post(appConfig.api.login3rd, user)
                    .then(res => {
                        const userService = new UserService()
                        userService.setToken(res.data.token)

                        if (res.data.is_created) {
                            helper.gTrackEvent('register', {
                                event_category: 'Register',
                                event_label: user.eventLabel
                            })
                        }

                        this.$emit(
                            'login-success',
                            userService.getUser(),
                            this.isSponsor,
                            userService.getUser().is_prompt_newsletter
                        )

                        this.triggerEventLoginSuccess({
                            provider: user.provider,
                            isCreated: res.data.is_created
                        })

                        this.isLoading = false
                        resolve()
                    })
                    .catch(err => {
                        const res = err.response

                        this.isLoading = false

                        if (typeof res.data.data.status != 'undefined') {
                            return popup.alert(
                                res.data.data.status == 'suspended'
                                    ? this.translate('auth_login_alert_lock_account')
                                    : ''
                            )
                        }

                        reject()
                    })
            })
        },

        triggerEventLoginSuccess() {
            this.$nextTick(() => {
                const userService = new UserService()
                if (!this.isSponsor && !userService.getUser().is_prompt_newsletter && !this.preventNewsletterPopup) {
                    this.openNewsletterModal()
                }
            })

            const loginSuccessEvent = new CustomEvent('login-success')
            window.dispatchEvent(loginSuccessEvent)
        },

        loginSuccess(res) {
            const userService = new UserService()
            userService.setToken(res.token)
            if (window.location.pathname == '/' || window.location.pathname.indexOf('/quiz') == 0) {
                return this.$emit(
                    'login-success',
                    userService.getUser(),
                    this.isSponsor,
                    userService.getUser().is_prompt_newsletter
                )
            }

            this.$emit(
                'login-success',
                userService.getUser(),
                this.isSponsor,
                userService.getUser().is_prompt_newsletter
            )

            this.triggerEventLoginSuccess()

            this.isLoading = false

            this.tmpUserEmail = userService.getUser().email
            this.emailInput = this.tmpUserEmail

            this.$nextTick(() => {
                if (!this.isSponsor && !userService.getUser().is_prompt_newsletter) {
                    this.openNewsletterModal()
                }
            })
        },

        loginMemberSuccess(res) {
            const userService = new UserService()
            userService.setToken(res.token)
            if (window.location.pathname == '/' || window.location.pathname.indexOf('/quiz') == 0) {
                return this.$emit(
                    'login-success',
                    userService.getUser(),
                    this.isSponsor,
                    userService.getUser().is_prompt_newsletter
                )
            }

            this.$emit(
                'login-success',
                userService.getUser(),
                this.isSponsor,
                userService.getUser().is_prompt_newsletter
            )

            this.triggerEventLoginSuccess()

            this.isLoading = false

            this.tmpUserEmail = userService.getUser().email
            this.emailInput = this.tmpUserEmail

            this.showOneTimeModal = false
            this.showOneTimeContent = false

            this.$nextTick(() => {
                if (!this.isSponsor && !userService.getUser().is_prompt_newsletter) {
                    this.openNewsletterModal()
                }
            })
        },

        registerSuccess(res) {
            const userService = new UserService()
            userService.setToken(res.token)

            this.$emit('register-success', userService.getUser(), this.isSponsor, false)

            this.triggerEventLoginSuccess()
            this.trackRegisterInGame()

            this.isLoading = false

            if (!this.isSponsor && !this.preventNewsletterPopup) {
                this.openNewsletterModal()
            }
        },

        toggleLogin() {
            this.stage = 'login'
        },

        toggleRegister() {
            this.stage = 'register'
        },

        toggleAddEmail() {
            this.stage = 'add-email'
        },

        closeByBackdrop(e) {
            if (!e.target.classList.contains('modal-backdrop') || this.stage == 'loginOTP') {
                return
            }
            if (this.isLoading == false) {
                this.$emit('close')
            } else {
                this.$emit('open')
            }
        },

        closeModal() {
            this.isLoading = false
            this.$emit('close')

            setTimeout(() => {
                // Solved php close modal glitch
                this.stage = 'login'
                this.showOneTimeModal = false
                this.showOneTimeContent = false
            }, 500)
        },

        afterResetPassword() {
            this.$emit('close')
            this.stage = 'login'
        },

        trackRegisterInGame() {
            const routes = ['play-alone-result', 'play-alone-summary', 'result']

            if (this.$route && routes.indexOf(this.$route.name) > -1) {
                var parentQuizCode = this.$route.params.code
                var label = 'PlayAlone'

                if (this.$route.name === 'result') {
                    parentQuizCode = this.$store.getters['player/parentQuizCode']
                    label = 'PlayLive'
                }

                helper.gTrackEvent('register', {
                    event_category: label,
                    event_label: `StartPlay_${parentQuizCode}_register`,
                    transport_type: 'beacon'
                })
            } else {
                let paths = window.location.pathname.split('/').filter(path => path)
                let quizCodew = paths[1]

                if (quizCodew) {
                    helper.gTrackEvent('register', {
                        event_category: 'QuizLanding',
                        event_label: `StartPlay_${quizCodew}_register`,
                        transport_type: 'beacon'
                    })
                }
            }
        },

        async sponsorVideoMeta() {
            if (
                typeof this.sponsorQuiz != 'undefined' &&
                typeof this.sponsorQuiz.sponsor_setting != 'undefined' &&
                this.sponsorQuiz.sponsor_setting.sponsor_page_youtube_id.length > 0
            ) {
                const ytLink = this.sponsorQuiz.sponsor_setting.sponsor_page_youtube_id
                let url
                if (ytLink.includes('youtube')) {
                    url = await new URL(ytLink)
                } else {
                    url = await new URL(
                        `https://www.youtube.com/watch?v=${ytLink}&modestbranding=1&autohide=1&showinfo=0&controls=0`
                    )
                }

                const baseURL = process.env.VUE_APP_ROOT_URL
                let videoParams = await url.searchParams.get('v')
                this.videoMeta = {
                    video: videoParams,
                    img_url: `${baseURL}yt/${videoParams}`,
                    provider: 'youtube'
                }
            }
        },

        sponsorQuizTrack(key) {
            if (key == 'video') {
                if (!this.isMuted) {
                    this.muted = true
                    this.$store.commit('updateIsMuted', this.muted)
                }
            }
            this.$emit('sponsor-quiz-track', key)
        },

        onSubmitForm(slug, value) {
            this.$nextTick(() => {
                this.$validator.validate().then(result => {
                    if (!result) {
                        if (slug != 'contact') {
                            if (this.errors.items[0].field == 'email') {
                                this.emailInput = this.userEmail
                            } else if (this.errors.items[0].field == 'phone') {
                                this.telInput = ''
                                this.contactSwitch = true
                            }
                            this.errors.clear()
                        } else {
                            return false
                        }
                    }

                    this.isLoading = true

                    let payload = {
                        key: slug,
                        value: value
                    }

                    this.$emit('send-contact', payload)
                })
            })
        },

        async changeContact(boo) {
            let emailInput = document.querySelector('#email-input')
            let telInput = document.querySelector('#tel-input')
            let value

            if (this.errors.items.length > 0) {
                if (this.errors.items[0].field == 'email') {
                    this.emailInput = this.userEmail
                } else if (this.errors.items[0].field == 'tel') {
                    this.telInput = ''
                }
            }

            this.contactSwitch = boo

            this.errors.clear()

            if (this.contactSwitch) {
                this.emailInput = emailInput.value
                value = emailInput.value
            } else {
                this.telInput = telInput.value
                value = telInput.value
            }

            this.onSubmitForm('contact', value)
        },

        setLoader(boo) {
            this.isLoading = boo
        },

        isLoggedIn() {
            const userService = new UserService()

            return userService.isLoggedIn()
        },

        setUserContactData(info) {
            if (info.contact_type == 'email') {
                this.emailInput = info.contact
                this.contactSwitch = true
            } else if (info.contact_type == 'phone') {
                this.telInput = info.contact
                this.contactSwitch = false
            }

            this.sponsorMaillist = info.sponsor_maillist
            this.tbqMaillist = info.tbq_maillist
        },

        openNewsletterModal() {
            this.closeModal()

            if (!this.getIsSchoolRoles()) {
                this.$store.commit('setShowNewsletterModal', true)
            }
        },

        handleClearInput() {
            this.$refs.oneTimeAuth.clearInput()
        },

        getRecaptchaSiteKey() {
            return process.env.VUE_APP_RECAPTCHA_SITE_KEY
        },

        handleInput(data) {
            this.$refs.oneTimeAuth.showLoader(true)
            this.$validator.validate().then(async result => {
                const request = new Request()
                const otpInputs = document.querySelectorAll('.otp-input')
                let inputErr = 0

                const recaptcha = await load(this.getRecaptchaSiteKey(), {
                    useRecaptchaNet: true,
                    autoHideBadge: true
                })

                const token = await recaptcha.execute('validate_captcha', {
                    action: 'validate_captcha'
                })

                otpInputs.forEach(e => {
                    if (!e.value) {
                        inputErr += 1
                    }
                })

                if (!result || inputErr) {
                    return false
                }

                let form = {
                    login_token: data.login_token,
                    otp: data.otp,
                    otp_ref: data.otp_ref,
                    email: data.email,
                    auth_select: data.auth_select,
                    name: data.name,
                    key_google2fa: data.key_google2fa,
                    captcha_response: token
                }

                if (this.isSchoolPage()) {
                    form.email = data.email
                    form.school_name = data.school_name
                    form.school_district = data.school_district
                    form.school_country = data.school_country
                    form.school_country_name = data.school_country_name
                    form.school_phone = data.school_phone
                    form.school_slug = data.school_slug
                }

                let url = null

                if (data['type'] == 'register') {
                    url = appConfig.api.registerOneTime
                } else {
                    url = !data.is_google2fa ? appConfig.api.loginOtp : appConfig.api.loginGoogle2fa
                }

                await request
                    .post(url, form)
                    .then(res => {
                        this.loginSuccess = true

                        setTimeout(() => {
                            this.loginMemberSuccess(res.data)
                        }, 300)
                        this.isLoading = false
                    })
                    .catch(err => {
                        const res = err.response

                        this.isLoading = false
                        this.$refs.oneTimeAuth.showLoader(false)
                        this.handleClearInput()
                        return popup.alert(
                            res.data.data.errOnetime == 'otp'
                                ? this.translate('auth_login_alert_otp_wrong')
                                : this.translate('auth_login_alert_2fa_wrong')
                        )
                    })
            })
        },

        openOneTimeLogin(data) {
            this.isLoading = true
            this.showOneTimeModal = true
            this.$nextTick(() => {
                this.$refs.oneTimeAuth.onOtp(data)
            })
        },

        onRegisterOtp(data) {
            this.isLoading = true
            this.showOneTimeModal = true
            this.$nextTick(() => {
                this.$refs.oneTimeAuth.onShow(data)
            })
        },

        async openConfirmToTeacherModal(data) {
            this.cacheData = data

            await this.$nextTick()

            this.showConfirmToTeacherModal = true
        },

        async openSetSchoolModal() {
            this.showOneTimeContent = true
            this.showConfirmToTeacherModal = false

            await this.$nextTick()

            this.showSetschoolModal = true
        },

        rejectCallback() {
            this.showConfirmToTeacherModal = false

            if (this.cacheData.thirdParty) {
                this.login3rd(this.cacheData)
                return
            }

            this.onRegisterOtp(this.cacheData)
        }
    }
}
</script>

<style lang="scss">
$input-border-color: #cbcbcb;
$input-border-darker-color: #b6b6b6;

.auth-modal {
    .auth-popup-header {
        margin-bottom: 3rem;
    }

    .small-btn {
        display: flex;
        justify-content: center;
        gap: 28px;
    }

    .modal-backdrop {
        background-color: rgba(0, 0, 0, 0.2);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: start;
        font-size: 0.5rem;
        z-index: 9999;
        padding-top: 30px;

        .modal-box {
            width: 720px;
            @media screen and (max-width: 719px) {
                width: 96%;
            }
        }

        .modal-content {
            background-color: #fff;
            // margin-top: 4rem;
            padding: 1rem;
            max-width: 720px;
            width: 100%;
            // overflow: unset !important;
            border-radius: 3px;
            box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);

            @media screen and (max-width: 719px) {
                min-width: 90%;
                &.mb-content {
                    max-height: 83%;
                    height: auto;

                    &.sponsor-page {
                        max-height: 83%;
                        height: 100%;
                    }
                }
            }

            .inner-loader {
                top: 0;
                left: 0;
            }

            .modal-body {
                // margin: 0 0 4rem 0;
                height: 100%;
                padding-bottom: 20px;
                overflow: hidden;

                &.sponsor-body {
                    height: 560px;
                    padding-top: 61px;
                    padding-bottom: 16px;
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    row-gap: 12px;
                }

                .max-w-school {
                    max-width: 24.5rem;
                }

                @media screen and (max-width: 719px) {
                    margin: 0 0 1rem 0;
                    &.sponsor-body {
                        height: 455px;
                        padding-top: 0;
                        padding-bottom: 0;
                        margin: 0;
                    }
                }
            }
        }
    }

    .separator {
        display: flex;
        align-items: center;
        text-align: center;
        color: $input-border-color;
        font-size: 1rem;

        &::before,
        &::after {
            content: '';
            flex: 1;
            border-bottom: 1px solid $input-border-color;
        }

        &::before {
            margin-right: 2rem;
        }

        &::after {
            margin-left: 2rem;
        }
    }

    .auth-input {
        display: block;
        width: 100%;
        border: 1px solid $input-border-color;
        font-size: 1rem;
        padding: 0.8rem;
        border-radius: 3px;
        text-align: center;

        &::placeholder {
            font-weight: bold;
            text-align: center;
            color: $input-border-color;
        }

        &.button {
            cursor: pointer;
            color: $input-border-darker-color;
            font-weight: bold;
            background-color: #fff;

            &:hover {
                background-color: #f0f0f0;
            }

            &.button-success {
                background-color: #009d1a;
                color: #fff;

                &:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }

                &:hover {
                    background-color: #018f19;
                    color: #fff;
                }
            }
        }

        &.is-invalid {
            border-color: #ef0000 !important;
        }
    }

    .invalid-feedback {
        color: #ef0000;
        font-size: 0.7rem;
        text-align: center;
        margin-top: 0.4rem;
    }

    .sponsor-logo {
        width: 150px;
        height: 150px;
        border: 2px solid #fff;
        border-radius: 50%;
        overflow: hidden;
        position: absolute;
        top: -60px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 100;

        img {
            width: 100%;
            height: 100%;
        }

        @media screen and (max-width: 719px) {
            width: 100px;
            height: 100px;
            top: -40px;
        }
    }

    .login-box {
        max-height: 64vh;
        height: auto;
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        overflow-y: auto;
        text-align: center;

        @media screen and (min-width: 768px) and (max-height: 1024px) {
            max-height: 60vh;
        }

        @media screen and (max-width: 767px) {
            row-gap: 8px;

            .login-form {
                padding-bottom: 16px;
            }
        }

        &.sponsor-without-media {
            max-width: unset;
            height: 100%;
            justify-content: space-between;
        }

        .sponsor-box {
            .sponsor-headline {
                font-size: 24px;
                margin-top: 0;
            }

            .sponsor-body {
                font-size: 16px;
                margin-bottom: 16px;
            }
        }

        .contact-header {
            font-size: 16px;
            font-weight: bold;
        }

        .contact-box {
            margin-top: 16px;
            display: flex;
            flex-direction: column;
            row-gap: 8px;

            @media screen and (max-width: 767px) {
                margin-top: 8px;
                row-gap: 4px;
            }

            .contact-input-box {
                align-items: flex-start;

                .check-box {
                    margin-top: 0.7rem;
                }
            }

            .check-box.big {
                min-width: 28px;
                min-height: 28px;

                @media screen and (max-width: 767px) {
                    min-width: 26px;
                    min-height: 26px;

                    .checkmark {
                        top: 3px;
                        left: 7px;
                    }
                }
            }

            span {
                width: 100%;
                .contact-input {
                    border: 1px solid #cbcbcb;
                    border-radius: 3px;
                    font-size: 16px;
                }

                @media screen and (max-width: 719px) {
                    font-size: 14px;
                }
            }

            .contact-checkbox {
                width: 28px;
                height: 28px;
                margin: 0;

                @media screen and (max-width: 767px) {
                    width: 26px;
                    height: 26px;
                }
            }

            .receive-text {
                font-size: 16px;
                @media screen and (max-width: 719px) {
                    font-size: 14px;
                }
            }

            @media screen and (max-width: 719px) {
                max-width: unset;
            }
        }

        @media screen and (max-width: 719px) {
            .sponsor-box {
                .sponsor-headline {
                    font-size: 20px;
                }

                .sponsor-body {
                    font-size: 14px;
                    margin-bottom: 8px;
                }

                .sponsor-btn {
                    font-size: 16px;
                }
            }

            .contact-header {
                font-size: 14px;
            }
        }
    }

    .sponsor-btn {
        text-decoration: none;
        font-size: 18px;
        font-weight: bold;
        color: #000;
    }

    .sponsor-video-box {
        width: fit-content;
        height: 260px;
        margin: 0 auto;
        background-color: #b8c2cc;
        @media screen and (max-width: 719px) {
            width: 100%;
            min-height: 140px;
            height: auto;
            aspect-ratio: 16 / 9;
        }

        .video-container {
            aspect-ratio: 16 / 9;
            height: 260px;

            @media screen and (max-width: 719px) {
                height: 100%;
            }
        }
    }

    .column-gap-16 {
        column-gap: 16px;
    }

    .object-contain {
        object-fit: contain;
    }

    .ok-btn {
        padding: 20px 24px;
    }

    .compete-btn {
        height: 40px;
    }

    .container {
        row-gap: 2rem;

        > div > div {
            column-gap: 4px;
        }

        .otp-input {
            width: 40px;
            height: 45px;
            padding: 5px;
            margin: 0 2px;
            font-size: 20px;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.3);
            text-align: center;
            -moz-appearance: textfield;

            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            &.error {
                border: 1px solid red !important;
            }

            @media screen and (max-width: 400px) {
                width: 35px;
                height: 40px;
                font-size: 18px;
            }
        }
        .otp-input::-webkit-inner-spin-button,
        .otp-input::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        button {
            position: relative;
            font-size: 16px;
            padding: 5px 15px;
            border: none;
        }

        .btn-confirm-otp {
            height: 40px;
            padding: 0 16px;
            font-size: 16px;
            font-weight: bold;
            border: none;
            border-radius: 4px;
            color: #fff;
            background-color: #000;
            cursor: pointer;
        }
    }
}
</style>
